import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.source_1 = source;
        this.closed_1 = false;
        this.bufferField_1 = new (Buffer())();
      }
      get_buffer_bmaafd_k$() {
        return this.bufferField_1;
      }
      readAtMostTo_4oop6l_k$(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        if (this.bufferField_1.get_size_woubt6_k$() === 0n) {
          var read = this.source_1.readAtMostTo_4oop6l_k$(this.bufferField_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.bufferField_1.get_size_woubt6_k$();
        var toRead = byteCount <= b ? byteCount : b;
        return this.bufferField_1.readAtMostTo_4oop6l_k$(sink, toRead);
      }
      exhausted_p1jt55_k$() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return this.bufferField_1.exhausted_p1jt55_k$() && this.source_1.readAtMostTo_4oop6l_k$(this.bufferField_1, 8192n) === -1n;
      }
      require_37jki9_k$(byteCount) {
        if (!this.request_hj5jqj_k$(byteCount))
          throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      request_hj5jqj_k$(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        while (this.bufferField_1.get_size_woubt6_k$() < byteCount) {
          if (this.source_1.readAtMostTo_4oop6l_k$(this.bufferField_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      readByte_ectjk2_k$() {
        this.require_37jki9_k$(1n);
        return this.bufferField_1.readByte_ectjk2_k$();
      }
      readAtMostTo_kub29z_k$(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.bufferField_1.get_size_woubt6_k$() === 0n) {
          var read = this.source_1.readAtMostTo_4oop6l_k$(this.bufferField_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.bufferField_1.get_size_woubt6_k$();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$1 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$1);
        return this.bufferField_1.readAtMostTo_kub29z_k$(sink, startIndex, startIndex + toRead | 0);
      }
      readTo_3vtbf7_k$(sink, byteCount) {
        try {
          this.require_37jki9_k$(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.write_ob3ym3_k$(this.bufferField_1, this.bufferField_1.get_size_woubt6_k$());
            throw e;
          } else {
            throw $p;
          }
        }
        this.bufferField_1.readTo_3vtbf7_k$(sink, byteCount);
      }
      transferTo_lu4ka2_k$(sink) {
        var totalBytesWritten = 0n;
        while (!(this.source_1.readAtMostTo_4oop6l_k$(this.bufferField_1, 8192n) === -1n)) {
          var emitByteCount = this.bufferField_1.completeSegmentByteCount_46ltjp_k$();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.write_ob3ym3_k$(this.bufferField_1, emitByteCount);
          }
        }
        if (this.bufferField_1.get_size_woubt6_k$() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.bufferField_1.get_size_woubt6_k$());
          sink.write_ob3ym3_k$(this.bufferField_1, this.bufferField_1.get_size_woubt6_k$());
        }
        return totalBytesWritten;
      }
      readShort_ilpyey_k$() {
        this.require_37jki9_k$(2n);
        return this.bufferField_1.readShort_ilpyey_k$();
      }
      peek_21nx7_k$() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      close_yn9xrc_k$() {
        if (this.closed_1)
          return Unit_instance;
        this.closed_1 = true;
        this.source_1.close_yn9xrc_k$();
        this.bufferField_1.clear_j9egeb_k$();
      }
      toString() {
        return 'buffered(' + toString(this.source_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
